<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <medical-view :claim="claim" :modal="modalMedicalView" @closeModal="modalMedicalView = false" @refreshData="refreshData"></medical-view>
    <traces :claim="claim" :modal="modalTrace" @closeModal="modalTrace = false"></traces>
    <agreed-amount :claim="claim" :modal="modalAgreedAmount" @closeModal="modalAgreedAmount = false"></agreed-amount>
    <sign-attachments :claim="claim" :modal="modalSignAttachments" @closeModal="modalSignAttachments = false"></sign-attachments>
    <div v-if="modalVictim" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline"  style="max-height: 70vh;">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="victim.person">
                {{ victim.person.name }}
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <table class="min-w-full">
                  <thead v-for="vf in victimFiles" :key="vf.id">
                    <tr @click="toogleFileOptions(vf)">
                      <th
                        class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                      >
                        <img v-if="vf.icon" :src="require('../assets/files/'+vf.icon)" />
                        <span>{{ vf.name }}</span>
                        <svg
                          class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            v-if="!vf.active"
                            d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"
                          ></path>
                          <path 
                            v-if="vf.active"
                            d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                          </path>
                        </svg>
                      </th>
                    </tr>
                    <tr v-for="o in vf.options" :key="o.id" v-show="vf.active">
                      <td 
                        :class="[o.loaded ? 'text-gray-500' : 'text-red-500']"
                        class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-50">
                          {{ o.name }}
                          <span class="flex items-center">
                            <a v-if="o.loaded && !o.plus" href="#" @click="downloadVictimFile(o)" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.loaded && !o.plus" href="#" @click="removeVictimFile(o)">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-red-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.plus && o.loaded && othersVictimUploads.typeFileId != vf.id" href="#" @click="viewVictimOthersUpload(o)" class="pr-2">
                              <svg
                                class="w-6 h-6 mr-2 -ml-1 text-gray-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.plus && o.loaded && othersVictimUploads.typeFileId == vf.id" href="#" @click="othersVictimUploads.typeFileId = null" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-orange-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                                </path>
                              </svg>
                            </a>
                          </span>
                      </td>
                    </tr>
                    <tr v-for="(other, index) in othersVictimUploads.files" :key="other.name+index" v-show="othersVictimUploads.typeFileId == vf.id">
                      <td 
                        class="flex items-center justify-between px-6 py-3 text-black-500 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-300">
                        {{ other.name }} {{ index+1 }}
                        <span class="flex items-center">
                          <a href="#" @click="downloadVictimOtherFile(other)" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-green-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                              </path>
                            </svg>
                          </a>
                          <a href="#" @click="removeVictimOtherFile(other)">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-red-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                              </path>
                            </svg>
                          </a>
                        </span>
                      </td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalVictim = false"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-grey-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M3.24,7.51c-0.146,0.142-0.146,0.381,0,0.523l5.199,5.193c0.234,0.238,0.633,0.064,0.633-0.262v-2.634c0.105-0.007,0.212-0.011,0.321-0.011c2.373,0,4.302,1.91,4.302,4.258c0,0.957-0.33,1.809-1.008,2.602c-0.259,0.307,0.084,0.762,0.451,0.572c2.336-1.195,3.73-3.408,3.73-5.924c0-3.741-3.103-6.783-6.916-6.783c-0.307,0-0.615,0.028-0.881,0.063V2.575c0-0.327-0.398-0.5-0.633-0.261L3.24,7.51 M4.027,7.771l4.301-4.3v2.073c0,0.232,0.21,0.409,0.441,0.366c0.298-0.056,0.746-0.123,1.184-0.123c3.402,0,6.172,2.709,6.172,6.041c0,1.695-0.718,3.24-1.979,4.352c0.193-0.51,0.293-1.045,0.293-1.602c0-2.76-2.266-5-5.046-5c-0.256,0-0.528,0.018-0.747,0.05C8.465,9.653,8.328,9.81,8.328,9.995v2.074L4.027,7.771z">
                </path>
              </svg>
              Volver
            </button>
          </span>
        </div>
      </div>
    </div>

    <div v-if="modalMove" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all md:w-auto sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline">  
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline">
                Mover Reclamo
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
               <div class="py-4">
                    <div class="inline-block relative">
                      <select v-model="stateSelected" class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                        <option v-for="s in states" :key="s.id" :value="s">{{ s.name }}</option>
                      </select>
                      <span v-if="modalMoveError" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                        {{ modalMoveError }} 
                      </span>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                      </div>
                    </div>
                </div>   
                <div class="py-4" v-if="stateSelected && stateSelected.id == statePendingCommission">
                    <input v-model="linkMercadoPago" type="text" placeholder="Link Mercadopago" :class="linkMercadoPagoError != null ? 'border-red-500' : ''" class="text-sm w-3/3 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                    <span v-if="linkMercadoPagoError" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                      {{ linkMercadoPagoError }}
                    </span>
                </div> 
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalMove = false"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>

          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button 
              @click="move"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>

          <span class="pr-4">
            <div v-if="loading">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#338BFF">
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"/>
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
          </span>
        </div>

      </div>
    </div>

    <div class="sm:px-6 lg:px-8">
      <div class="h-full bg-white shadow-2xl">
        
        <div class="font-sans bg-grey-lighter flex flex-col min-h-screen w-full">
          <div class="flex-grow container mx-auto sm:px-4 pt-6 pb-8">
            <div class="bg-white border-t border-b sm:border-l sm:border-r sm:rounded shadow mb-1">
              <div class="border-b px-6">
                <div class="flex justify-between -mb-px">
                  <div class="hidden lg:flex">
                    <span v-if="claim" class="px-6 py-3 text-xs font-medium leading-4 text-center text-blue-500 uppercase border-b border-blue-200">
                      <span
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-blue-500 transition duration-150 hover:text-gray-600"
                      >
                        <svg
                          class="w-5 h-5 mr-2 -ml-1 text-white-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M18.807,0.337h-3.616v1.808c0,0.475-0.384,0.859-0.859,0.859c-0.474,0-0.859-0.384-0.859-0.859V0.337H6.731
                v1.808c0,0.475-0.384,0.859-0.859,0.859c-0.474,0-0.859-0.384-0.859-0.859V0.337h-3.82c-0.474,0-0.859,0.384-0.859,0.859v17.61
                c0,0.477,0.384,0.859,0.859,0.859h17.613c0.474,0,0.859-0.382,0.859-0.859V1.195C19.665,0.721,19.281,0.337,18.807,0.337z
                M17.948,17.946H2.052V4.528h15.896V17.946z"></path>
                        </svg>
                        {{ claim.date_hour | fechaHora }}
                      </span>
                    </span>
                    <span v-if="claim" class="px-6 py-3 text-xs font-medium leading-4 text-center text-blue-500 uppercase border-b border-blue-200">
                      <span
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-blue-500 transition duration-150 hover:text-gray-600"
                      >
                        <svg
                          class="w-5 h-5 mr-2 -ml-1 text-white-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M6.99999861,6.00166547 C6.99999861,4.34389141 8.3465151,3 9.99999722,3 C11.6568507,3 12.9999958,4.33902013 12.9999958,6.00166547 L12.9999958,7.99833453 C12.9999958,9.65610859 11.6534793,11 9.99999722,11 C8.34314374,11 6.99999861,9.66097987 6.99999861,7.99833453 L6.99999861,6.00166547 Z M3.34715433,14.4444439 C5.37306718,13.5169611 7.62616222,13 10,13 C12.3738388,13 14.6269347,13.5169615 16.6528458,14.4444437 C15.2177146,16.5884188 12.7737035,18 10,18 C7.22629656,18 4.78228556,16.5884189 3.34715433,14.4444439 L3.34715433,14.4444439 Z"></path>
                        </svg>
                        {{ claim.person.name }}
                        <svg
                            v-if="claim.state.id == stateMedicalView || ((claim.state.id == stateInicial || claim.state.id == stateComplete) && claim.medical)"
                            @click="modalMedicalView = true"
                            class="w-5 h-5 text-red-400 cursor-pointer"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                          <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z"></path>
                        </svg>
                        <svg
                            v-else-if="claim.medical"
                            class="w-5 h-5 text-red-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                          <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z"></path>
                        </svg>
                        <svg
                            v-if="claim.other_person"
                            class="w-5 h-5 text-orange-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                          <path d="M15.573,11.624c0.568-0.478,0.947-1.219,0.947-2.019c0-1.37-1.108-2.569-2.371-2.569s-2.371,1.2-2.371,2.569c0,0.8,0.379,1.542,0.946,2.019c-0.253,0.089-0.496,0.2-0.728,0.332c-0.743-0.898-1.745-1.573-2.891-1.911c0.877-0.61,1.486-1.666,1.486-2.812c0-1.79-1.479-3.359-3.162-3.359S4.269,5.443,4.269,7.233c0,1.146,0.608,2.202,1.486,2.812c-2.454,0.725-4.252,2.998-4.252,5.685c0,0.218,0.178,0.396,0.395,0.396h16.203c0.218,0,0.396-0.178,0.396-0.396C18.497,13.831,17.273,12.216,15.573,11.624 M12.568,9.605c0-0.822,0.689-1.779,1.581-1.779s1.58,0.957,1.58,1.779s-0.688,1.779-1.58,1.779S12.568,10.427,12.568,9.605 M5.06,7.233c0-1.213,1.014-2.569,2.371-2.569c1.358,0,2.371,1.355,2.371,2.569S8.789,9.802,7.431,9.802C6.073,9.802,5.06,8.447,5.06,7.233 M2.309,15.335c0.202-2.649,2.423-4.742,5.122-4.742s4.921,2.093,5.122,4.742H2.309z M13.346,15.335c-0.067-0.997-0.382-1.928-0.882-2.732c0.502-0.271,1.075-0.429,1.686-0.429c1.828,0,3.338,1.385,3.535,3.161H13.346z"></path>
                        </svg>
                        <svg
                          v-if="claim.mechanical"
                          class="w-5 h-5 text-gray-800 float-right"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M4.68,13.716v-0.169H4.554C4.592,13.605,4.639,13.658,4.68,13.716z M11.931,6.465
      c-0.307-0.087-0.623,0.106-0.706,0.432l-1.389,5.484c-0.901,0.084-1.609,0.833-1.609,1.757c0,0.979,0.793,1.773,1.773,1.773
      c0.979,0,1.773-0.794,1.773-1.773c0-0.624-0.324-1.171-0.812-1.486l1.377-5.439C12.422,6.887,12.239,6.552,11.931,6.465z
      M10.591,14.729H9.408v-1.182h1.183V14.729z M15.32,13.716c0.04-0.058,0.087-0.11,0.126-0.169H15.32V13.716z M10,3.497
      c-3.592,0-6.503,2.911-6.503,6.503H4.68c0-2.938,2.382-5.32,5.32-5.32s5.32,2.382,5.32,5.32h1.182
      C16.502,6.408,13.591,3.497,10,3.497z M10,0.542c-5.224,0-9.458,4.234-9.458,9.458c0,5.224,4.234,9.458,9.458,9.458
      c5.224,0,9.458-4.234,9.458-9.458C19.458,4.776,15.224,0.542,10,0.542z M15.32,16.335v0.167h-0.212
      c-1.407,1.107-3.179,1.773-5.108,1.773c-1.93,0-3.701-0.666-5.108-1.773H4.68v-0.167C2.874,14.816,1.724,12.543,1.724,10
      c0-4.571,3.706-8.276,8.276-8.276c4.57,0,8.275,3.706,8.275,8.276C18.275,12.543,17.126,14.816,15.32,16.335z"></path>
                        </svg>
                      </span>
                    </span>
                    <div v-if="claim" class="flex justify-center items-center m-1 py-1 px-2 rounded-full text-green-700 bg-green-100 border border-green-300 ">
                        <div class="text-xs font-xs leading-none max-w-full flex-initial">{{ claim.patent }}</div>
                    </div>
                    <div v-if="claim" class="flex justify-center items-center m-1 py-1 px-2 rounded-full text-gray-700 bg-gray-100 border border-gray-300 ">
                        <div v-if="claim.insurance" class="text-xs font-xs leading-none max-w-full flex-initial">{{ claim.insurance.name }}</div>
                    </div>
                  </div>
                  
                  <div v-if="chat" :class="[chat.noread > 0 ? 'text-red-400' : 'text-green-400']" class="flex text-sm">
                    <router-link v-if="claim" :to="{ name: 'Chat', params: { claimId: claim.id }}">
                      <svg
                        :class="[chat.noread > 0 ? 'text-red-400' : 'text-green-400']"
                        class="w-10 h-10 mr-2 -ml-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                      <path d="M14.9,6.707c-0.804-2.497-3.649-4.351-7.035-4.351c-4.008,0-7.27,2.594-7.27,5.782
                        c0,2.163,1.516,4.133,3.903,5.122v3.091c0,0.251,0.144,0.478,0.372,0.586c0.087,0.042,0.182,0.062,0.276,0.062
                        c0.148,0,0.295-0.051,0.412-0.15l3.678-3.038c0.14-0.022,0.275-0.057,0.413-0.084c0.655,0.666,1.544,1.185,2.607,1.46
                        c0.198,0.051,0.401,0.094,0.608,0.125l2.641,2.182c0.118,0.099,0.264,0.15,0.413,0.15c0.094,0,0.188-0.02,0.276-0.062
                        c0.228-0.108,0.372-0.335,0.372-0.586v-2.135c1.74-0.761,2.84-2.231,2.84-3.846C19.405,8.862,17.456,7.073,14.9,6.707z
                        M8.885,12.552c-0.019,0.003-0.032,0.018-0.051,0.022c-0.101,0.022-0.2,0.056-0.281,0.123l-2.76,2.28v-2.161
                        c0-0.275-0.175-0.521-0.434-0.612C3.253,11.467,1.89,9.871,1.89,8.138c0-2.474,2.68-4.487,5.975-4.487
                        c2.604,0,4.801,1.265,5.617,3.014c0.187,0.401,0.302,0.823,0.33,1.268c0.005,0.069,0.028,0.134,0.028,0.205
                        c0,1.819-1.481,3.438-3.706,4.129c-0.115,0.037-0.224,0.08-0.343,0.111C9.497,12.455,9.196,12.513,8.885,12.552z M15.703,13.809
                        c-0.259,0.091-0.434,0.336-0.434,0.612v1.199l-1.723-1.422c-0.095-0.079-0.211-0.129-0.333-0.144
                        c-0.219-0.028-0.431-0.068-0.636-0.121c-0.545-0.14-1.023-0.364-1.433-0.64c2.423-0.969,3.99-2.942,3.99-5.155
                        c0-0.024-0.004-0.047-0.005-0.071c1.718,0.385,2.98,1.553,2.98,2.948C18.11,12.202,17.165,13.299,15.703,13.809z"></path>
                      <path d="M4.68,7.591h6.167c0.358,0,0.648-0.29,0.648-0.648s-0.29-0.648-0.648-0.648H4.68
                        c-0.358,0-0.648,0.29-0.648,0.648S4.323,7.591,4.68,7.591z"></path>
                      <path d="M8.709,8.636H4.68c-0.358,0-0.648,0.29-0.648,0.648c0,0.358,0.29,0.648,0.648,0.648h4.028
                        c0.358,0,0.648-0.29,0.648-0.648C9.356,8.926,9.067,8.636,8.709,8.636z"></path>
                      </svg>
                    </router-link>
                    ({{ chat.noread }})
                  </div>

                  <svg
                    v-if="claim"
                    @click="modalTrace = true"
                    class="w-10 h-10 mr-2 -ml-1 text-gray-400 cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10,1.445c-4.726,0-8.555,3.829-8.555,8.555c0,4.725,3.829,8.555,8.555,8.555c4.725,0,8.555-3.83,8.555-8.555C18.555,5.274,14.725,1.445,10,1.445 M10,17.654c-4.221,0-7.654-3.434-7.654-7.654c0-4.221,3.433-7.654,7.654-7.654c4.222,0,7.654,3.433,7.654,7.654C17.654,14.221,14.222,17.654,10,17.654 M14.39,10c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,9.55,14.39,9.752,14.39,10 M14.39,12.702c0,0.247-0.203,0.449-0.45,0.449H6.06c-0.248,0-0.45-0.202-0.45-0.449c0-0.248,0.203-0.451,0.45-0.451h7.879C14.187,12.251,14.39,12.454,14.39,12.702 M14.39,7.298c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,6.848,14.39,7.051,14.39,7.298">
                    </path>
                  </svg>

                  <svg
                    v-if="claim && claim.state && claim.state.id == stateMedicalView"
                    @click="modalMedicalView = true"
                    class="w-8 h-8 mr-2 -ml-1 text-red-600 cursor-pointer pt-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z">
                    </path>
                  </svg>

                  <svg
                    v-if="claim && claim.state.id == stateInNegotiation"
                    @click="modalAgreedAmount = true"
                    class="w-10 h-10 mr-2 -ml-1 text-blue-600 cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
                  </svg>

                  <svg
                    v-if="claim && (claim.state.id == statePendingPayment || claim.state.id == statePendingCommission || claim.state.id == stateClosed)"
                    @click="viewInfoPayment(claim)"
                    class="w-10 h-10 mr-2 -ml-1 text-blue-600 cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
                  </svg>

                  <svg
                    v-if="claim && claim.state.id == statePendingPayment"
                    @click="modalSignAttachments = true"
                    class="w-10 h-10 mr-2 -ml-1 text-black cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M4.317,16.411c-1.423-1.423-1.423-3.737,0-5.16l8.075-7.984c0.994-0.996,2.613-0.996,3.611,0.001C17,4.264,17,5.884,16.004,6.88l-8.075,7.984c-0.568,0.568-1.493,0.569-2.063-0.001c-0.569-0.569-0.569-1.495,0-2.064L9.93,8.828c0.145-0.141,0.376-0.139,0.517,0.005c0.141,0.144,0.139,0.375-0.006,0.516l-4.062,3.968c-0.282,0.282-0.282,0.745,0.003,1.03c0.285,0.284,0.747,0.284,1.032,0l8.074-7.985c0.711-0.71,0.711-1.868-0.002-2.579c-0.711-0.712-1.867-0.712-2.58,0l-8.074,7.984c-1.137,1.137-1.137,2.988,0.001,4.127c1.14,1.14,2.989,1.14,4.129,0l6.989-6.896c0.143-0.142,0.375-0.14,0.516,0.003c0.143,0.143,0.141,0.374-0.002,0.516l-6.988,6.895C8.054,17.836,5.743,17.836,4.317,16.411"></path>
                  </svg>

                  <div 
                    v-if="claim" 
                    class="flex justify-center items-center m-1 py-1 px-2 rounded-full text-purple-700 bg-purple-100 border border-purple-300 cursor-pointer"
                    @click="modalMove = true; modalMoveError = null; loading = false; stateSelected = null"
                    >
                      <div class="text-xs font-xs leading-none max-w-full flex-initial">{{ claim.state.name }}</div>
                      <svg
                        class="w-8 h-8 mr-2 -ml-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M16.198,10.896c-0.252,0-0.455,0.203-0.455,0.455v2.396c0,0.626-0.511,1.137-1.138,1.137H5.117c-0.627,0-1.138-0.511-1.138-1.137V7.852c0-0.626,0.511-1.137,1.138-1.137h5.315c0.252,0,0.456-0.203,0.456-0.455c0-0.251-0.204-0.455-0.456-0.455H5.117c-1.129,0-2.049,0.918-2.049,2.047v5.894c0,1.129,0.92,2.048,2.049,2.048h9.488c1.129,0,2.048-0.919,2.048-2.048v-2.396C16.653,11.099,16.45,10.896,16.198,10.896z"></path>
                        <path d="M14.053,4.279c-0.207-0.135-0.492-0.079-0.63,0.133c-0.137,0.211-0.077,0.493,0.134,0.63l1.65,1.073c-4.115,0.62-5.705,4.891-5.774,5.082c-0.084,0.236,0.038,0.495,0.274,0.581c0.052,0.019,0.103,0.027,0.154,0.027c0.186,0,0.361-0.115,0.429-0.301c0.014-0.042,1.538-4.023,5.238-4.482l-1.172,1.799c-0.137,0.21-0.077,0.492,0.134,0.629c0.076,0.05,0.163,0.074,0.248,0.074c0.148,0,0.294-0.073,0.382-0.207l1.738-2.671c0.066-0.101,0.09-0.224,0.064-0.343c-0.025-0.118-0.096-0.221-0.197-0.287L14.053,4.279z"></path>
                      </svg>
                  </div>

                  <div class="pt-2 flex text-sm">
                    <span v-if="claim">
                      <img :src="require('../assets/displacement_type/'+claim.displacement_type.icon)" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="claim && (claim.responsable.name || claim.responsable.identity_document || claim.responsable.tel || claim.responsable.adress)" class="bg-white border-t border-b sm:border-l sm:border-r sm:rounded shadow mb-1">
               <div class="border-b px-6">
                <div class="flex justify-between -mb-px">
                  <div class="hidden lg:flex">
                    <span class="px-6 py-3 text-xs font-medium leading-4 text-center text-blue-500 uppercase border-b border-blue-200">
                      <span class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600">
                        Datos del que te chocó:
                      </span>
                      <span v-if="claim.responsable.name"
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600"
                      >
                        {{ claim.responsable.name }}
                      </span>
                      <span v-if="claim.responsable.identity_document"
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600"
                      >
                        DNI: {{ claim.responsable.identity_document }}
                      </span>
                      <span v-if="claim.responsable.tel"
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600"
                      >
                        Teléfono: {{ claim.responsable.tel }}
                      </span>
                      <span v-if="claim.responsable.adress"
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600"
                      >
                        Domicilio: {{ claim.responsable.adress }}
                      </span>
                      <span v-if="claim.responsable.city"
                        class="inline-flex items-center mx-2 text-xs font-medium leading-5 text-red-500 transition duration-150 hover:text-gray-600"
                      >
                        {{ claim.responsable.city.name }}, {{ claim.responsable.city.province.name }} 
                      </span>
                    </span>
                  </div>
                </div>
               </div>
            </div>

            <div class="flex flex-wrap -mx-4">
              <div class="w-full mb-6 lg:mb-0 lg:w-1/2 px-4 flex flex-col">
                <div class="flex-grow flex flex-col bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden">
                  <div class="border-b">
                    <div class="flex justify-between px-6 -mb-px">
                      <h1 class="text-blue-dark py-4 font-normal text-md">DOCUMENTACIÓN</h1>
                    </div>
                  </div>
                  <div class="flex-grow flex px-6 py-6 text-grey-darker items-center border-b -mx-4">
                    <table class="min-w-full">
                      <thead v-for="f in files" :key="f.id">
                        <tr @click="toogleFileOptions(f)">
                          <th
                            class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                          >
                            <img v-if="f.icon" :src="require('../assets/files/'+f.icon)" />
                            <span>{{ f.name }}</span>
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                v-if="!f.active"
                                d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"
                              ></path>
                              <path 
                                v-if="f.active"
                                d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                              </path>
                            </svg>
                          </th>
                        </tr>
                        <tr v-for="o in f.options" :key="o.id" v-show="f.active">
                          <td 
                            :class="[o.loaded ? 'text-gray-500' : 'text-red-500']"
                            class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-50">
                              {{ o.name }}
                              <span class="flex items-center">
                                <a v-if="o.loaded && !o.plus" href="#" @click="downloadFile(o)" class="pr-2">
                                  <svg
                                    class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                    </path>
                                  </svg>
                                </a>
                                <a v-if="o.loaded && !o.plus" href="#" @click="removeFile(o)">
                                  <svg
                                    class="w-5 h-5 mr-2 -ml-1 text-red-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                                    </path>
                                  </svg>
                                </a>
                                <a v-if="o.plus && o.loaded && othersUploads.typeFileId != f.id" href="#" @click="viewOthersUpload(o)" class="pr-2">
                                  <svg
                                    class="w-6 h-6 mr-2 -ml-1 text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z">
                                    </path>
                                  </svg>
                                </a>
                                <a v-if="o.plus && o.loaded && othersUploads.typeFileId == f.id" href="#" @click="othersUploads.typeFileId = null" class="pr-2">
                                  <svg
                                    class="w-5 h-5 mr-2 -ml-1 text-orange-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                                    </path>
                                  </svg>
                                </a>
                              </span>
                          </td>
                        </tr>
                        <tr v-for="(other, index) in othersUploads.files" :key="other.name+index" v-show="othersUploads.typeFileId == f.id">
                          <td 
                            class="flex items-center justify-between px-6 py-3 text-black-500 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-300">
                            {{ other.name }} {{ index+1 }}
                            <span class="flex items-center">
                              <a href="#" @click="downloadOtherFile(other)" class="pr-2">
                                <svg
                                  class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                  </path>
                                </svg>
                              </a>
                              <a href="#" @click="removeOtherFile(other)">
                                  <svg
                                    class="w-5 h-5 mr-2 -ml-1 text-red-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                                    </path>
                                  </svg>
                                </a>
                            </span>
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="w-full mb-6 lg:mb-0 lg:w-1/2 px-4 flex flex-col">
                <div class="bg-white border-t border-b sm:rounded sm:border shadow">
                  <div class="border-b">
                    <div class="flex justify-between px-6 -mb-px">
                      <h1 v-if="claim" class="text-blue-dark py-4 font-normal text-md">{{ claim.street_route }}, {{ claim.city.name }}, {{ claim.city.province.name }}</h1>
                    </div>
                  </div>
                  <div v-if="claim">
                    <img v-if="claim.circulation_type" :src="require('../assets/circulation_type/'+claim.circulation_type.icon)" />
                    <div v-if="claim.displacement_circulation" class="bg-gray-200 mt-4 mb-4 ml-4 mr-4 shadow-lg rounded-lg">
                      <div>
                        <p class="pt-2 pl-2 pr-2 pb-2 text-red-500">{{ claim.displacement_circulation }}</p>
                      </div>
                    </div>
                    <!--
                    <div v-if="claim.audio && !modalMove" class="flex pt-2 justify-center">
                      <audio controls>
                          <source :src="claim.audio" type="audio/mpeg">
                          El browser utilizado no soporta reproducción de audio.
                      </audio>
                    </div>
                    -->
                  </div>
                  <div v-if="claim">
                    <div v-for="t in claim.types" :key="t.id" class="flex justify-center items-center m-1 font-medium py-1 px-2 rounded-full text-red-700 bg-red-100 border border-red-300">
                      <div class="text-xs font-normal leading-none max-w-full flex-initial">{{ t.name }}</div>
                    </div>
                  </div>
                  <div class="pl-1 pb-1 pr-1 flex flex-wrap -mx-4" v-if="claim && claim.victims.length > 0">
                    <div class="w-full mb-6 lg:mb-0 px-4 flex flex-col">
                      <div class="flex-grow flex flex-col bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden">
                          <table class="min-w-full">
                            <thead>
                              <tr><th colspan="3" class="text-xs text-white border-red-200 bg-red-400">Otras Víctimas</th></tr>
                            </thead>
                            <tbody>
                              <tr v-for="victim in claim.victims" :key="victim.id">
                                <td 
                                  class="flex items-center justify-between px-6 py-1 text-xs text-gray-700 font-medium leading-4 tracking-wider uppercase border-t border-red-200 bg-red-50">
                                  {{ victim.person.name }}
                                </td>
                                <td
                                  class="text-xs text-gray-800 border-t border-red-200 bg-red-50">
                                  <span v-if="victim.type" class="text-xs font-xs leading-none max-w-full flex-initial">{{ victim.type.name }}</span>
                                  <span v-if="victim.type2" class="text-xs font-xs leading-none max-w-full flex-initial"> - {{ victim.type2.name }}</span>
                                </td>
                                <td
                                  class="border-t border-red-200 bg-red-50">
                                    <svg
                                      @click="viewFiles(victim)"
                                      class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                                    </svg>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>   
</template>

<script>
import Traces from '@/components/Traces'
import MedicalView from '@/components/MedicalView'
import AgreedAmount from '@/components/AgreedAmount'
import SignAttachments from '@/components/SignAttachments'
import Vue from 'vue'
import '@/filter.js'
import VueAlertify from 'vue-alertify';
import { ConstantMap } from '@/constant.js'

Vue.use(VueAlertify);

export default {
  components: { Traces, MedicalView, AgreedAmount, SignAttachments },

  data() {
    return {
      claim: null,
      files: null,
      chat: null,
      victim: null,
      victimFiles: null,
      modalMove: false,
      modalVictim: false,
      loading: false,
      states: null,
      stateSelected: null,
      modalMoveError: null,
      modalTrace: false,
      modalMedicalView: false,
      modalAgreedAmount: false,
      modalSignAttachments: false,
      othersUploads: {
        typeFileId: null,
        files: []
      },
      othersVictimUploads: {
        typeFileId: null,
        files: []
      },
      stateInicial: ConstantMap.STATE_INICIAL,
      stateComplete: ConstantMap.STATE_COMPLETE,
      stateMedicalView: ConstantMap.STATE_MEDICAL_VIEW,
      stateNoOffer: ConstantMap.STATE_NO_OFFER,
      stateInNegotiation: ConstantMap.STATE_IN_NEGOTIATION,
      statePendingPayment: ConstantMap.STATE_PENDING_PAYMENT,
      statePendingCommission: ConstantMap.STATE_PENDING_COMMISSION,
      stateClosed: ConstantMap.STATE_CLOSED,
      linkMercadoPagoError: null, 
      linkMercadoPago: null
    }
  },

  mounted() {
    this.init()
    setInterval(() => {this.getChat()}, 60000)
  },

  methods: {
    async init () {
      this.getFiles()
      await this.getClaim()
      this.getChat()
      this.getStates()
    },
    async getClaim() {
      const result = await this.$http.get(`/claims/${this.$route.params.id}`)
      this.claim = result.data
    },
    async getFiles() {
      this.files = await this.$http.get(`type/files/${this.$route.params.id}`)
    },
    async getChat() {
      this.chat = await this.$http.get(`chats/claim/${this.claim.id}/noread`)
    },
    async getStates() {
      this.states = await this.$http.get('/claimState/all')
    },
    toogleFileOptions(fileOptions) {
      fileOptions.active = !fileOptions.active
    },
    async downloadFile(option){
      const params = {
        file_option_id : option.id
      }
      const response = await this.$http.get(`claims/${this.claim.id}/file`, {params: params})
      
      const linkSource = response.data.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = option.name;
      downloadLink.click();
    },
    removeFile(option){
      const params = {
        file_option_id : option.id
      }

      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${option.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/${this.claim.id}/remove/file`, {params: params})
            option.loaded = false
            this.$alertify.success('El documento ha sido eliminado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    move(){
      let valid = true
      let params = {
        claim_state_id: this.stateSelected.id
      }

      if (this.stateSelected == null){
        this.modalMoveError = "Debe seleccionar un estado!"
        valid = false
      } else {
        if (this.stateSelected.id == this.statePendingCommission){
          params.link_mercadopago = this.linkMercadoPago
          if (this.linkMercadoPago == null || this.linkMercadoPago == ''){
            this.linkMercadoPagoError = "Debe ingresar link de MercadoPago!"
            valid = false
          }
        } 
      }

      if (valid){
        this.modalMoveError = null
        this.$alertify.confirmWithTitle(
          'Cambiar estado Reclamo',
          `¿Esta seguro que desea cambiar al estado ${this.stateSelected.name}?`,
          async () => {
            try {
              this.loading = true
              const resp = await this.$http.patch(`/claims/${this.claim.id}/state`, params)
              this.claim.state = resp.state
              this.$alertify.success('Cambio de estado realizado!') 
              this.loading = false
              this.modalMove = false
            } catch (error) {
              this.loading = false
              this.$alertify.error('ERROR. No se ha podido realizar el cambio de estado!')
            }   
          }
        ).set('labels', {ok:'Si', cancel:'No'});
      }
    },
    async viewFiles(victim){
      this.modalVictim = true
      this.victim = victim
      this.victimFiles = await this.$http.get(`claims/victim/${this.victim.id}/files`)
    },
    async downloadVictimFile(option){
      const params = {
        file_option_id : option.id
      }
      const response = await this.$http.get(`claims/victim/${this.victim.id}/file`, {params: params})
      
      const linkSource = response.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = option.name;
      downloadLink.click();
    },
    removeVictimFile(option){
      const params = {
        file_option_id : option.id
      }

      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${option.name} de ${this.victim.person.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/victim/${this.victim.id}/remove/file`, {params: params})
            option.loaded = false
            this.$alertify.success('El documento ha sido eliminado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async viewOthersUpload(option) {
      this.othersUploads.typeFileId = option.claim_type_files_id
      this.othersUploads.files = await this.$http.get(`type/files/${this.claim.id}/${option.id}`)
    },
    async downloadOtherFile(file){
      const response = await this.$http.get(`type/file/${file.id}`)
      
      const linkSource = response.data.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = file.name;
      downloadLink.click();
    },
    removeOtherFile(file){
      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${file.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/${file.id}/file`)
            this.$alertify.success('El documento ha sido eliminado!') 
            this.othersUploads.typeFileId = null
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async viewVictimOthersUpload(option) {
      this.othersVictimUploads.typeFileId = option.claim_type_files_id
      this.othersVictimUploads.files = await this.$http.get(`type/files/${this.victim.id}/${option.id}/victim`)
    },
    async downloadVictimOtherFile(file){
      const response = await this.$http.get(`type/file/${file.id}/victim`)
      
      const linkSource = response.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = file.name;
      downloadLink.click();
    },
    removeVictimOtherFile(file){
      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${file.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/victim/${file.id}/file`)
            this.$alertify.success('El documento ha sido eliminado!') 
            this.othersVictimUploads.typeFileId = null
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    refreshData(claimId){
      const currentState = this.states.filter(s => s.id == this.stateNoOffer)
      this.claim.state = currentState[0]
    },
    viewInfoPayment(claim){
      this.$alertify.alert(
        `${claim.code} - ${claim.state.name}`, 
        `<b>Monto Acordado</b><br>$ ${claim.amount_agreed}<br><br><b>Comisión</b><br>$ ${claim.amount_commission}`
      )
    }
  }
  
}
</script>
